function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function formatMinorMoney(value, currencyCode = 'EUR') {
    const amount = Number(value || 0) / 100;
    return `${currencyCode} ${amount.toFixed(2)}`;
}

function formatMoney(value, currencyCode = 'EUR') {
    return `${currencyCode} ${Number(value || 0).toFixed(2)}`;
}

export function buildMotoQuoteHtml(quote, options = {}) {
    const customerName = options.customerName || 'Customer';

    const brandName = quote?.motorcycle?.brandName || '';
    const modelOnly = quote?.motorcycle?.modelName || 'Motorcycle';
    const modelName = [brandName, modelOnly].filter(Boolean).join(' ');
    const bookingUrl = quote?.bookingUrl || '';

    const currencyCode =
        quote?.pricing?.currencyCode ||
        quote?.rental?.currencyCode ||
        'EUR';

    const totalPriceText =
        quote?.pricing?.totalPrice != null
            ? formatMinorMoney(quote.pricing.totalPrice, currencyCode)
            : null;

    const depositCents = quote?.policies?.deposit;
    const paymentMethods = quote?.policies?.paymentMethods || [];
    const depositMethods = quote?.policies?.depositMethods || [];
    const minimumAge = quote?.policies?.minimumAge;
    const license = quote?.policies?.license;
    const mileage = quote?.policies?.mileage;
    const extraKmCost = quote?.policies?.extraKmCost;
    const internationalLicenseRequired = !!quote?.policies?.internationalLicenseRequired;

    const includedItems = quote?.includedItems || [];
    const optionalExtras = quote?.optionalExtras || [];

    const bookingLine = bookingUrl
        ? `<p><strong>${escapeHtml(modelName)}</strong> - <a href="${escapeHtml(bookingUrl)}" target="_blank" rel="noreferrer">click here to book this motorcycle</a>${totalPriceText ? ` (${escapeHtml(totalPriceText)})` : ''}</p>`
        : `<p><strong>${escapeHtml(modelName)}</strong>${totalPriceText ? ` (${escapeHtml(totalPriceText)})` : ''}</p>`;

    const additionalInfoItems = [
        depositCents != null
            ? `<li><strong>Deposit:</strong> ${escapeHtml(formatMinorMoney(depositCents, currencyCode))} to pay at destination</li>`
            : `<li><strong>Deposit:</strong> N/A</li>`,
        depositMethods.length
            ? `<li><strong>Deposit payment methods accepted:</strong> ${escapeHtml(depositMethods.join(', '))}</li>`
            : `<li><strong>Deposit payment methods accepted:</strong> N/A</li>`,
        paymentMethods.length
            ? `<li><strong>Payment methods accepted for rental:</strong> ${escapeHtml(paymentMethods.join(', '))}</li>`
            : `<li><strong>Payment methods accepted for rental:</strong> N/A</li>`,
        minimumAge != null
            ? `<li><strong>Minimum age:</strong> ${escapeHtml(`${minimumAge} years`)}</li>`
            : `<li><strong>Minimum age:</strong> N/A</li>`,
        license
            ? `<li><strong>License:</strong> ${escapeHtml(license)}</li>`
            : `<li><strong>License:</strong> N/A</li>`,
        internationalLicenseRequired
            ? `<li>International license could be required.</li>`
            : '',
        mileage
            ? `<li><strong>Mileage included:</strong> ${escapeHtml(mileage)}</li>`
            : `<li><strong>Mileage:</strong> To be confirmed</li>`,
        extraKmCost != null
            ? `<li><strong>Cost per additional km:</strong> ${escapeHtml(formatMoney(extraKmCost, currencyCode))}</li>`
            : '',
    ]
        .filter(Boolean)
        .join('');

    const includedHtml = includedItems.length
        ? includedItems.map((item) => `<li>${escapeHtml(item)}</li>`).join('')
        : '<li>Included items to be confirmed.</li>';

    const optionalExtrasHtml = optionalExtras.length
        ? optionalExtras
            .map((extra) => {
                const suffix = extra?.priceType === 'PER_DAY' ? ' / day' : '';
                return `<li><strong>${escapeHtml(extra?.name || 'Extra service')}</strong> - ${escapeHtml(`${currencyCode} ${Number(extra?.price || 0).toFixed(2)}${suffix}`)}</li>`;
            })
            .join('')
        : '<li>No optional extras available.</li>';

    return `
    <p>Hello ${escapeHtml(customerName)},</p>

    <p>Thank you very much for contacting us. Based on your request, we suggest the following model.</p>

    ${bookingLine}

    <p><strong>Additional information:</strong></p>
    <ul>
      ${additionalInfoItems}
    </ul>

    <p><strong>These models include:</strong></p>
    <ul>
      ${includedHtml}
    </ul>

    <p><strong>You can also add the following extra services:</strong></p>
    <ul>
      ${optionalExtrasHtml}
    </ul>

    <p>Availability is subject to change at the time of booking.</p>

    <p>If you have any further questions, it would be a pleasure to assist you.</p>

    <p>Best regards,<br />RMB</p>
  `.trim();
}